var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-tj",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#060",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v365.7H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M0 0h512v146.3H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f8c300",
    transform: "translate(-256) scale(.73143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M672 340.7a12.5 12.5 0 0 1 23.3 5.9v50h9.4v-50a12.5 12.5 0 0 1 23.3-5.9 29.5 29.5 0 1 0-56 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M678.7 327.6a20 20 0 0 1 21.3 9.6 20 20 0 0 1 21.3-9.6 21.5 21.5 0 0 0-42.6 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M695.3 376.6a38 38 0 0 1-63.8 24.3 39.5 39.5 0 0 1-59.8 17.5c3.7 36.4 58.3 29 62.3-6.4 17.2 30.1 55 21.5 66-15.4z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "matrix(-1 0 0 1 1400 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M658.8 441.3c-7.6 16.5-22.8 19.3-36.1 6 0 0 5.3-3.8 11-4.8a18 18 0 0 1 4.3-14.3 22 22 0 0 1 9 11.8c8-1 11.8 1.3 11.8 1.3z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "rotate(9.4 700 804)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "rotate(18.7 700 804)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f8c300",
    strokeWidth: 16,
    d: "M603 478a340 340 0 0 1 194 0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700 380)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -140)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m488533-158734-790463 574305L0-513674l301930 929245-790463-574305z",
    transform: "scale(.00005)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    transform: "translate(-70 -121.2)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    transform: "translate(-121.2 -70)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    transform: "translate(-140)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTj);
export default __webpack_public_path__ + "static/media/tj.9749373197a14f802651677b7b6bce90.svg";
export { ForwardRef as ReactComponent };